import { createFileRoute } from '@tanstack/react-router';

import { RfqDetailPage } from '@/features/procurement/rfq-detail-page';

export const Route = createFileRoute('/_app/projects/$projectId/procurement/rfqs/$rfqId')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <RfqDetailPage {...params} />;
}
